"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./");
const date_based_1 = require("../validators/date-based");
class DateValidatorBuilderImpl extends _1.CommonValidatorBuilderImpl {
    constructor(validationRule) {
        super(validationRule);
    }
    buildRuleWith(validator) {
        this.validationRule.addValidator(validator);
        return this;
    }
    /*
     * ===========================
     * Date-based validation rules
     * ===========================
     */
    isBefore(date) {
        return this.buildRuleWith(new date_based_1.IsBeforeValidator(date));
    }
    isSameAs(date) {
        return this.buildRuleWith(new date_based_1.IsSameAsValidator(date));
    }
    isAfter(date) {
        return this.buildRuleWith(new date_based_1.IsAfterValidator(date));
    }
    isSameOrBefore(date) {
        return this.buildRuleWith(new date_based_1.IsSameOrBeforeValidator(date));
    }
    isSameOrAfter(date) {
        return this.buildRuleWith(new date_based_1.IsSameOrAfterValidator(date));
    }
    isBetween(date1, date2, lowerBoundary = "(", upperBoundary = ")") {
        return this.buildRuleWith(new date_based_1.IsBetweenValidator(date1, date2, lowerBoundary, upperBoundary));
    }
}
exports.DateValidatorBuilderImpl = DateValidatorBuilderImpl;
//# sourceMappingURL=DateValidatorBuilderImpl.js.map